import { add } from 'date-fns'
import React from 'react'

import { FilterActions, HomesFilters, InitialFilterState, useFiltersContext } from '@/context'
import useSupplySection from '@/hooks/useDashboard/useSupplySection'
import { useGuardedNavigate } from '@/hooks/useGuardedNavigate'

import { Card } from './Card'

const Supply = () => {
  const dashboardQuery = useSupplySection()
  const dashboardData = dashboardQuery?.data?.agmDashboard
  const navigate = useGuardedNavigate()
  const [, FilterDispatch] = useFiltersContext()

  const handleStandardHomes = (filter?: Partial<HomesFilters>) => {
    FilterDispatch(
      FilterActions.setFilters({
        filterName: 'homes',
        filters: {
          ...InitialFilterState['homesFilters'],
          standard: true,
          published: true,
          installed: true,
          ...filter,
        },
      }),
    )
    navigate('/homes')
  }

  const handleAutopilotHomes = (filter?: Partial<HomesFilters>) => {
    FilterDispatch(
      FilterActions.setFilters({
        filterName: 'homes',
        filters: {
          ...InitialFilterState['homesFilters'],
          autopilot: true,
          published: true,
          installed: true,
          ...filter,
        },
      }),
    )
    navigate('/homes')
  }

  const handleAutopilotMoveOuts = () => {
    const today = new Date()
    const sevenDays = add(new Date(), { days: 7 })
    FilterDispatch(
      FilterActions.setFilters({
        filterName: 'reservations',
        filters: {
          ...InitialFilterState['reservationsFilters'],
          autopilot: true,
        },
      }),
    )
    FilterDispatch(FilterActions.setReservationMoveOutRange({ r: { moveOutDate: today, moveOutMax: sevenDays } }))
    navigate('/reservations')
  }

  return (
    <>
      <h2 className="my-4 text-xl">Landing Supply</h2>
      <div className="grid grid-cols-3 grid-rows-1 place-items-stretch gap-3 md:gap-6">
        <Card
          label="Total Occupied Homes"
          loading={dashboardQuery?.isLoading}
          onClick={() => handleStandardHomes({ occupied: true })}
          value={dashboardData?.totalOccupiedStandardHomes || 0}
        />
        <Card
          label="Total Blocked Homes"
          loading={dashboardQuery?.isLoading}
          onClick={() => handleStandardHomes({ blocked: true, leased: true })}
          value={dashboardData?.totalBlockedStandardHomes || 0}
        />
        <Card
          label="Total Vacant Homes"
          loading={dashboardQuery?.isLoading}
          onClick={() => handleStandardHomes({ vacant: true, leased: true })}
          value={dashboardData?.totalVacantStandardHomes || 0}
        />
        <Card
          label="Total Homes"
          loading={dashboardQuery?.isLoading}
          onClick={() => handleStandardHomes({ leased: true })}
          value={dashboardData?.totalStandardHomes || 0}
        />
        <Card
          label="Occupancy"
          loading={dashboardQuery?.isLoading}
          percentage={true}
          value={dashboardData?.standardHomeOccupancy}
        />
      </div>

      <h2 className="my-4 text-xl">Autopilot Supply</h2>
      <div className="mb-8 grid grid-cols-3 grid-rows-1 place-items-stretch gap-3 md:gap-6">
        <Card
          label="Total Occupied Homes"
          loading={dashboardQuery?.isLoading}
          onClick={() => handleAutopilotHomes({ occupied: true })}
          value={dashboardData?.totalOccupiedAutopilotHomes || 0}
        />
        <Card
          label="Total Blocked Homes"
          loading={dashboardQuery?.isLoading}
          onClick={() => handleAutopilotHomes({ blocked: true })}
          value={dashboardData?.totalBlockedAutopilotHomes || 0}
        />
        <Card
          label="Total Vacant Homes"
          loading={dashboardQuery?.isLoading}
          onClick={() => handleAutopilotHomes({ vacant: true })}
          value={dashboardData?.totalVacantAutopilotHomes || 0}
        />
        <Card
          label="Total Homes"
          loading={dashboardQuery?.isLoading}
          onClick={handleAutopilotHomes}
          value={dashboardData?.totalAutopilotHomes || 0}
        />
        <Card
          label="Occupancy"
          loading={dashboardQuery?.isLoading}
          percentage={true}
          value={dashboardData?.autopilotHomeOccupancy}
        />
        <Card
          label="Upcoming Move-Outs"
          loading={dashboardQuery?.isLoading}
          onClick={handleAutopilotMoveOuts}
          subLabel="(Next 7 days)"
          value={dashboardData?.totalUpcomingAutopilotMoveOuts || 0}
        />
      </div>
    </>
  )
}

export default Supply
